import { createApi } from '@reduxjs/toolkit/query/react';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';
import type { StrictType } from 'tradera/utils/strict-type';

import type {
    WebChangePasswordApiRequest,
    WebChangePasswordApiResponse,
    WebChangePasswordSendVerificationSmsApiRequest,
    WebChangePasswordSendVerificationSmsApiResponse,
} from 'tradera/state/services/types/webapi-auth-generated';

export type StrictWebChangePasswordApiRequest =
    StrictType<WebChangePasswordApiRequest>;

export const StrictWebChangePasswordApiRequestTemplate: StrictWebChangePasswordApiRequest =
    {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        pinCode: '',
    };

export type StrictWebChangePasswordSendVerificationSmsApiRequest =
    StrictType<WebChangePasswordSendVerificationSmsApiRequest>;

export const StrictWebChangePasswordSendVerificationSmsApiRequestTemplate: StrictWebChangePasswordSendVerificationSmsApiRequest =
    {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        phoneNumber: '',
    };

export const changePasswordApi = createApi({
    reducerPath: 'changePasswordApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        changePassword: builder.mutation<
            WebChangePasswordApiResponse,
            StrictWebChangePasswordApiRequest
        >({
            query: (params) => ({
                url: '/api/webapi/auth/web/member/change-password/new-password',
                method: 'POST',
                body: params,
            }),
        }),
        sendSmsVerificationCode: builder.mutation<
            WebChangePasswordSendVerificationSmsApiResponse,
            StrictWebChangePasswordSendVerificationSmsApiRequest
        >({
            query: (params) => ({
                url: '/api/webapi/auth/web/member/change-password/send-sms-verification',
                method: 'POST',
                body: params,
            }),
        }),
    }),
});

export const { useChangePasswordMutation, useSendSmsVerificationCodeMutation } =
    changePasswordApi;
